<template>
    <div>
      <h2>{{ $t('BASICDATA')}}</h2>
      <div class="row">
        <div class="col-12">
      		<employee-form v-bind:formData="formData" v-bind:formError="formError" v-bind:simple="true"></employee-form>
          <div class="col-md-4 action"><a href="#" v-on:click.prevent="saveEmployee" class="btn btn-primary"><img src="../assets/img/icon-save.svg" alt=""> {{ $t('SAVECHANGES')}}</a></div>
        </div>
    	</div>
    </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import employeesApi from '@/api/employees'
import EmployeeForm from '@/components/EmployeeForm.vue'

export default {
  name: 'ProfileUser',
  data: function()
  {
    return {
      formData:
      {
        id: '',
        name: '',
        surname: '',
        userEmail: '',
        username: '',
        password: '',
        userGroup: '',
        status: ''
      },
      formError: {}
    };
  },
  components:
  {
    'employee-form': EmployeeForm
  },
  created: function()
  {
    var me = this;
    me.selectMyData();
  },
  methods:
  {
    selectMyData: function()
    {
      var me = this;
      employeesApi.selectMyData({}, function(data)
      {
        me.formData = data.root;
      });
    },
    saveEmployee: function()
    {
      var me = this;
      employeesApi.saveEmployee(me.formData, function(val)
      {
        if(val.error)
        {
          me.formError = val;
        }
        else
        {
          me.formError = {};
          me.$notify.success(val.notice);
        }
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ProfileUser.vue